import { ActionEnum } from '../action.enum';
import {
  ComponentClassGroupDetailMenuEnum
} from '../../enums/component-class-group/component-class-group-detail-menu.enum';
import { ModuleAttributeGroupSaveAllDto } from '../../models/module_attribute_group/ModuleAttributeGroupSaveAllDto';

export namespace ComponentClassGroupDetailAction {

  export class LoadComponentClassGroup {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_LOAD;
    constructor(public id: string) {}
  }

  export class SelectMenu {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_SELECT_MENU;
    constructor(public menu: ComponentClassGroupDetailMenuEnum) {}
  }

  export class DeleteComponentClassGroup {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_DELETE;
    constructor(public id: string) {}
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_RESET_STATE;
  }

  export class LoadClasses {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_LOAD_CLASSES;
  }

  export class ChangeClassSelection {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_CHANGE_CLASS_SELECTION;
    constructor(public ids: Set<string>) {}
  }

  export class SaveClassSelection {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_SAVE_CLASS_SELECTION;
  }

  export class ResetClassSelection {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_RESET_CLASS_SELECTION;
  }

  export class UpdateName {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_UPDATE_NAME;
    constructor(public name: string) {}
  }

  export class LoadDataFieldGroups {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_LOAD_DATA_FIELD_GROUPS;
  }

  export class SaveDataFieldGroups {
    static readonly type: ActionEnum = ActionEnum.COMPONENT_CLASS_GROUP_DETAIL_SAVE_DATA_FIELD_GROUPS;
    constructor(public dto: ModuleAttributeGroupSaveAllDto) {}
  }
}
